import React from 'react';
import { m } from 'framer-motion';
import { SectionTag } from '../ui/SectionTag';
import { differentiators } from '../../data/differentiators';
export function Differentiators() {
  return <section className="bg-white py-14 sm:py-16" data-id="element-29" data-mp="19dd9q4m5x4ku">
      <div className="mx-auto max-w-3xl px-6 text-center sm:px-8" data-id="element-30" data-mp="19e69glmpetth">
        <SectionTag icon="✓" data-id="element-31" data-mp="14l3m4v8isglq">El Estándar Profesional</SectionTag>
        <h2 className="mt-5 font-heading text-[28px] font-bold uppercase text-marino sm:text-[36px]" data-id="element-32" data-mp="1id9rdma4x36e">
          El Estándar Profesional en la Pista
        </h2>
      </div>

      <div className="mx-auto mt-10 grid max-w-6xl gap-5 px-6 sm:grid-cols-3 sm:px-8" data-id="element-33" data-mp="1dgjawxuf45kg">
        {differentiators.map((item, i) => <m.div key={item.title} initial={{
        opacity: 0,
        y: 14
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.4,
        delay: i * 0.08
      }} className={`rounded-2xl border-l-4 p-6 ${item.bgClass} ${item.borderClass}`} data-id="element-34" data-mp="1ncw7c3hckxiw" data-mpi={i}>
            <item.icon size={24} className={item.iconClass} data-id="element-35" data-mp="1b24coi9ite5s" />
            <h3 className="mt-3 font-heading text-xl font-bold text-marino" data-id="element-36" data-mp="1f1wrhcpicgjl">{item.title}</h3>
            <p className="mt-2 text-base leading-relaxed text-gris-texto" data-id="element-37" data-mp="1k1rgtbtmwy2j">{item.text}</p>
          </m.div>)}
      </div>
    </section>;
}